import React from "react";
import { Growl } from "primereact/growl";
import { Button } from 'primereact/button';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import servicioAsignacionValoresObjetos from "../servicio/ServicioObjetos";
import servicioHttp from "../servicio/ServicioHttp";
import { Paginator } from 'primereact/paginator';
import { Message } from 'primereact/message';
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Lightbox } from 'primereact/lightbox';
import ServicioArchivos from '../servicio/ServicioArchivos';
import '../componentes/Iframe.css';
import servicioFormatos from '../servicio/ServicioFormatos';
import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR } from '../servicio/ServicioConstantes';
import { Checkbox } from 'primereact/checkbox';
import servicioObjetos from "../servicio/ServicioObjetos";
const TODOS = { label: "Todos", value: 0 };


export class MovimientosRechazados extends React.Component {
    constructor() {
        super();
        this.state = {
            errores: {},
            registrosPatronales: [],
            registroPatronal: null,
            tcLote: {},
            paginacion: { registrosPorPagina: 20 },
            inicio: 0,
            iFrameSrc: null,
            consulta: {},
            errorRegistroPatronal: {},
            listaSeleccionados: [],
            checked: false,
            movimientosSeleccionados: []

        }
    }

    componentDidMount() {
        this.obtenerEmpresa();

    }

    asignarValores = (event, mayusculas) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, mayusculas);
    }


    obtenerEmpresa() {
        servicioHttp.consumirPostHttp('empresa/obtener_registro_patronal.json').then(response => {
            let registrosPatronales = [TODOS];
            var newArray = registrosPatronales.concat(response.data.lista);
            let { consulta } = this.state;
            consulta.registroPatronal = TODOS.value;
            this.setState({ registrosPatronales: newArray, consulta: consulta });
        }).catch(error => {

        });
    }

   

    cambiaPagina = (event) => {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first });
        const validacion = this.validarRequeridosForm();
        this.setState({ errores: validacion });
        if (servicioObjetos.esObjetoVacio(validacion)) {
            this.asignarRestricciones();
            this.obtenerResultados();
        }
    }
    

    asignarRestricciones = () => {
        let { paginacion, consulta } = this.state;
        paginacion.restriccionesDinamicas = [];
        paginacion.ordenamientos = [];
        paginacion.ordenamientos.push({
            tipo: 'desc',
            nombrePropiedad: 'alias_ttLoteSolicitudIdse.fecha'
        });

        paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq", nombrePropiedad: "estadoRespuesta",
                valorPropiedad: 1, fechaIncialBetween: null, fechaFinalBetween: null
            
        });

        if (!servicioObjetos.esObjetoVacio(consulta.fechaInicial) && !servicioObjetos.esObjetoVacio(consulta.fechaFinal)) {
            let fechaIncial = servicioFormatos.formatearFechaString(consulta.fechaInicial);
            let fechaFinal = servicioFormatos.formatearFechaString(consulta.fechaFinal).replace('00:00:00', '23:59:59');
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "between",
                nombrePropiedad: "alias_ttLoteSolicitudIdse.fecha",
                valorPropiedad: null,
                fechaIncialBetween: fechaIncial,
                fechaFinalBetween: fechaFinal
            });
        }

        if (!servicioObjetos.esObjetoVacio(consulta.registroPatronal) && consulta.registroPatronal !== 0) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_ttLoteSolicitudIdse.tcEmpresa.id",
                valorPropiedad: consulta.registroPatronal
            });
        }
    }

    
    buscar = () => {
        let { paginacion,inicio } = this.state;
        paginacion.numeroPagina=0;
        inicio=0;
        const validacion = this.validarRequeridosForm();
        this.setState({ errores: validacion,inicio });
        if (servicioObjetos.esObjetoVacio(validacion)) {
            this.asignarRestricciones();
            this.obtenerResultados();
        }
    }

    validarRequeridosForm = () => {
        let { consulta } = this.state;
        let errores = {};
        if (consulta.fechaInicial == null)
            errores.fechaInicial = "La fecha Inicial es requerida";
        if (consulta.fechaFinal == null)
            errores.fechaFinal = "La fecha final es requerida";
        return errores;
    }

    obtenerResultados = () => {
        let { paginacion, movimientosSeleccionados } = this.state;
        servicioHttp.consumirPostHttp("movimientos/consulta_rechazados.json", paginacion).then((response) => {
            this.setState({ paginacion: response.data.objeto });
            for (var i = 0; i < response.data.objeto.datos.length; i++) {
                if (response.data.objeto.datos[i].estadoReenvio === 1) {
                    movimientosSeleccionados.push(response.data.objeto.datos[i]);

                }
                this.setState({ movimientosSeleccionados });
            }
        }).catch(() => { 

        });
    }
    
    
    plantillaTipoMovimiento = (rowData, column) => {
        if (rowData.tipoMovimiento === "08")
            return <div>Reingreso</div>;
        if (rowData.tipoMovimiento === "07")
            return <div>Modificación</div>;
        if (rowData.tipoMovimiento === "02")
            return <div>Baja</div>;
    }
    plantillaCodigoError = (rowData, column) => {
        return servicioAsignacionValoresObjetos.esObjetoVacio(rowData.descripcionErrorAfil)?null:rowData.descripcionErrorAfil.substring(0, 3);
    }
    consultarConstancia = (objeto) => {

    }
    visorAfil = (objeto) => {
        ServicioArchivos.descargaArchivoComoBlob('/documentos/descarga_acuse.json', { archivoAcuseRecibo: objeto.archivoAfil })
            .then((response) => {
                this.setState({ iFrameSrc: URL.createObjectURL(response) });
                document.getElementById("btnVisorPdfTarget").click();
            }).catch((error) => {
                console.log(error);
                this.growl.show({ severity: 'error', summary: 'Error', detail: 'No se encutra el archivo' });
            });
    }
    cambiarEstatusReenvio = (objeto, estadoReenvio) => {
        servicioHttp.consumirPostHttp("movimientos/cambiar_reenvio.json", { id: objeto.id , estadoReenvio:estadoReenvio}).then((response) => {
        this.buscar();
        }).catch(() => { });
    }


    templateFechaMovimiento = (rowData, column) => {
        return servicioFormatos.formatearFechaStringIdse(rowData.fechaMovimiento);
    }
    templateSalarioDiario = (rowData, column) => {
        return servicioFormatos.formatoSalarioDiarioIntegradoString(rowData.salarioDiarioIntegrado);
    }
    columnaFecha = (rowData, column) => {
        return <div>{servicioFormatos.formatearFecha(rowData.fecha)}</div>;
    }

    descargarReporteExcel = () => {          
        const validacion = this.validarRequeridosForm();
        this.setState({ errores: validacion });
        this.asignarRestricciones();
        if (servicioObjetos.esObjetoVacio(validacion)) {
            let { paginacion } = this.state;  
            let paginacionCopia={...paginacion};
            paginacionCopia.numeroPagina=0;
            paginacionCopia.clase = null;
            paginacionCopia.claseWrapper = null; 
            paginacionCopia.join={
                "ttLoteSolicitudIdse": "alias_ttLoteSolicitudIdse",
                "alias_ttLoteSolicitudIdse.tcEmpresa": "alias_tcEmpresa",
                "tcTrabajador": "alias_tcTrabajador"
            };
                                       
            ServicioArchivos.descargaArchivo('/movimientos/movimientos_rechazados.json', paginacionCopia);
        }
    }
    columnaBotonConstancia(rowData, column) {
        return (
            <div className="p-grid">
                <div className="p-col-12 p-md-12">
                    <Button
                        type="button"
                        onClick={(e) => this.visorAfil(column.rowData)}
                        name="constancia"
                        label="constancia"
                        tooltip="Constancia"
                        icon="pi-md-file-download"
                    ></Button>
                </div>
            </div>
        );

    }
    columnaBotonReenvio(rowData, column) {
        return (

            <div className="p-grid">
                {rowData.estadoReenvio === 0 ?
                    <div className="p-col-12 p-md-12">
                        <Button
                            type="button"
                            onClick={(e) => this.cambiarEstatusReenvio(column.rowData)}
                            name="reenvio"
                            label=" "
                            tooltip="Reenvio"
                        ></Button>
                    </div>
                    : null}
                {rowData.estadoReenvio === 1 ?
                    <div className="p-col-12 p-md-12">
                        <Button
                            type="button"

                            name="reenvio"
                            label="Reenviado"
                            tooltip="Reenviado"
                            icon="pi-md-send"
                        ></Button>
                    </div>
                    : null}
            </div>
        );

    }
   
    plantillaChecBox = (rowData, column) => {
        return <Checkbox inputId="cb1" value={rowData} onChange={this.validarRegistrosObjetos} checked={this.state.movimientosSeleccionados.indexOf(rowData) !== -1} ></Checkbox>


    }
    validarRegistrosObjetos = (e) => {
        let { movimientosSeleccionados } = this.state;
        let respuesta = movimientosSeleccionados.findIndex(element => element === e.value);
        if (e.checked) {
            if (respuesta === -1) {
                movimientosSeleccionados.push(e.value);
                this.cambiarEstatusReenvio(e.value, 1);
                
            }
        } else {
            movimientosSeleccionados.splice(respuesta, 1);
            
            this.cambiarEstatusReenvio(e.value, 0);
        }
        this.setState({ movimientosSeleccionados: movimientosSeleccionados });
        
    }

    templateNombre = (rowData, column) => {
        return servicioFormatos.formatearNombreTrabajador(rowData);
    }



    

    render() {
        let { inicio, errores, registrosPatronales, paginacion, iFrameSrc, consulta, errorRegistroPatronal } = this.state;
        const visorPdfTarget = (
            <button id="btnVisorPdfTarget" className="p-link" style={{ visibility: "hidden" }}></button>
        );        
        return (
            <div className="p-fluid">
                <div className="p-grid">
                    <Growl ref={(el) => (this.growl = el)} />
                    <Lightbox target={visorPdfTarget}>
                        <div id="contenedorIframe"  >
                            <iframe id="elIframe" src={iFrameSrc} frameBorder="0" className="iframeEstilo" title="pdf"></iframe>
                        </div>
                    </Lightbox>
                    <div className="p-col-12">
                        <div className="card card-w-title">
                            <h1>Movimientos Rechazados</h1>
                            <div className="p-grid p-fluid">
                                <div className="p-col-12 p-md-4">
                                    <label >Registro Patronal:</label>
                                </div>
                                <div className="p-col-12 p-md-8">
                                    <Dropdown filter={true} filterPlaceholder="Filtra por RP o Nombre corto" 
                                    filterBy="value,label" showClear={true}
                                    appendTo={document.body} id="consulta.registroPatronal" 
                                    name="consulta.registroPatronal" optionLabel="label" 
                                    options={registrosPatronales} value={consulta.registroPatronal} 
                                    onChange={(e) => this.asignarValores(e, false)} autoWidth={false} 
                                    style={{ width: "100%" }} 
                                    className={errorRegistroPatronal.error ? "p-error" : ""} />

                                </div>

                                <div className="p-col-12 p-md-4">
                                    <h4>*Fechas de Transmisión: entre:</h4>
                                    <Calendar id="fechaInicial" name="consulta.fechaInicial" value={consulta.fechaInicial} onChange={(e) => { this.asignarValores(e, false) }} className={errores.fechaInicial ? 'p-error' : ''} dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX} />
                                    {errores.fechaInicial ? <div><br /> <Message severity="error" text={errores.fechaInicial} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <h4> y:</h4>
                                    <Calendar id="fechaFinal" name="consulta.fechaFinal" value={consulta.fechaFinal || ''} onChange={(e) => { this.asignarValores(e, false) }} className={errores.fechaFinal ? 'p-error' : ''} dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX} />
                                    {errores.fechaFinal ? <div><br /> <Message severity="error" text={errores.fechaFinal} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <br /><br /><br />
                                    <Button label="Buscar" icon="pi-md-search" onClick={this.buscar} />
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <br /><br /><br />
                                    <Button label="Generar reporte" icon="pi-md-folder" onClick={this.descargarReporteExcel} />
                                </div>
                            </div>
                            <div className="p-grid">
                                <div className="p-col-12">
                                    <div className="card card-w-title">
                                        <DataTable value={paginacion.datos}
                                            header="Bitacora de movimientos rechazados"
                                            responsive={true} resizableColumns={true}


                                        >
                                            <Column body={this.plantillaChecBox} header="Mov. Reenviado" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />

                                            <Column
                                                header="Lote"
                                                field="loteIdImss"
                                                style={{ width: '100px' }} autoLayout={true} resizableColumns={true}

                                            />
                                            <Column
                                                header="Registro Patronal"
                                                field="registroPatronal"
                                                style={{ width: '120px' }} autoLayout={true} resizableColumns={true}
                                            />
                                            <Column
                                                header="Tipo de Movimiento"
                                                field="tipoMovimiento"
                                                style={{ width: '50px' }} autoLayout={true} resizableColumns={true}
                                            />
                                            <Column
                                                header="Descripción del movimiento"
                                                body={this.plantillaTipoMovimiento}
                                                style={{ width: '250px' }} autoLayout={true} resizableColumns={true}
                                            />
                                            <Column
                                                header="Fecha de transmisión"
                                                body={this.columnaFecha}
                                                style={{ width: '150px' }} autoLayout={true} resizableColumns={true}
                                            />
                                            <Column
                                                header="Fecha Movimiento"
                                                body={this.templateFechaMovimiento}
                                                style={{ width: '150px' }} autoLayout={true} resizableColumns={true}
                                            />
                                            <Column
                                                header="NSS"
                                                field="numeroSeguridadSocial"
                                                style={{ width: '110px' }} autoLayout={true} resizableColumns={true}
                                            />                                           
                                            <Column
                                                header="Nombre"
                                                body={this.templateNombre}
                                                style={{ width: '250px' }} autoLayout={true} resizableColumns={true}
                                            />
                                            <Column
                                                header="Código de error"
                                                body={this.plantillaCodigoError}
                                                style={{ width: '50px' }} autoLayout={true} resizableColumns={true}
                                            />
                                            <Column
                                                header="Motivo de rechazo"
                                                field="descripcionErrorAfil"
                                                style={{ width: '200px' }} autoLayout={true} resizableColumns={true}
                                            />
                                            <Column
                                                header="Nombre SINDO"
                                                field="nombreSindo"
                                                style={{ width: '200px' }} autoLayout={true} resizableColumns={true}
                                            />
                                            
                                            <Column
                                                header=""
                                                body={this.columnaBotonConstancia.bind(this)}
                                                style={{ width: '200px' }} autoLayout={true} resizableColumns={true}
                                            />
                                        </DataTable>
                                        <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        );
    }
}